import React, {
  createContext,
  memo,
  useContext,
  useEffect,
  useMemo,
} from 'react';
import { Form } from 'antd';
import { QuestionLayoutTemplates } from './questionLayoutTemplates';
import { SurveyWelcomeNote } from './surveyWelcomeNote';
import { AddQuestion } from './addQuestion';
import { SurveyExitPoint } from './exitPoint';
import ThemeOption from './SurveyThemeOption';
import InputSelector from '@Component/form/InputSelector';
import { fetchThemeList } from '@Redux/slices/channel/surveyThemeSlice';
import { useDispatch } from 'react-redux';
import './questionSection.scss';

const QuestionProvider = createContext({});

function QuestionsSection(props) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const settingValue = Form.useWatch('setting', form);
  const initialValues = useMemo(() => {
    const { theme, css, ...rest } = props.initialValues;

    const styles = { theme, css };

    return { styles, ...rest };
  }, [props.initialValues]);

  const value = useMemo(() => {
    const { attributes, currentType, currentEvent, events, businessEvents } =
      props;

    return {
      attributes,
      currentType,
      currentEvent,
      events,
      businessEvents,
    };
  }, [props]);

  useEffect(() => {
    if (settingValue?.layout) {
      dispatch(fetchThemeList(settingValue?.layout));
    }
  }, [settingValue?.layout]);

  return (
    <QuestionProvider.Provider value={value}>
      <div className="question-section">
        <Form
          form={form}
          layout="vertical"
          onFieldsChange={([field]) => {
            const [name] = field.name ?? [];

            if (name === 'styles') {
              props.onChange('styles', {
                ...initialValues.styles,
                ...field.value,
              });
            } else {
              props.onChange(name, field.value);
            }
          }}
          initialValues={initialValues}
        >
          <Form.Item name="setting">
            <QuestionLayoutTemplates
              onLayoutChange={(name) => {
                const styles = form.getFieldValue('styles');
                form.setFieldValue('styles', { ...styles, theme: undefined });
                if (name) dispatch(fetchThemeList(name));
              }}
            />
          </Form.Item>
          <Form.Item name="welcome">
            <SurveyWelcomeNote />
          </Form.Item>
          <Form.Item name="questions">
            <AddQuestion
              extraRender={() => {
                const setting = form.getFieldValue('setting');

                return (
                  <div
                    className="question-add-header"
                    hidden={setting?.layout !== 'ON_SITE_MODAL'}
                  >
                    <span style={{ color: '#707070' }}>Header</span>
                    <Form.Item
                      name="questionHeader"
                      hidden={setting?.layout !== 'ON_SITE_MODAL'}
                    >
                      <InputSelector
                        {...value}
                        isRich
                        type="rich"
                        showAttributePicker
                        showEmojiPicker
                        placeholder="header..."
                      />
                    </Form.Item>
                  </div>
                );
              }}
              restoreQuestions={(questions) =>
                form.setFieldValue('questions', questions)
              }
              partialUpdateQuestions={(callback) => {
                props.partialUpdateQuestions(form.getFieldsValue(), callback);
              }}
            />
          </Form.Item>
          {/* <Form.Item name="email">
            <SurveyEmail />
          </Form.Item> */}
          <Form.Item name="exitPoint">
            <SurveyExitPoint />
          </Form.Item>
          <Form.Item name="styles">
            <ThemeOption
              customFonts={props.customFonts}
              settingValue={settingValue}
            />
          </Form.Item>
        </Form>
      </div>
    </QuestionProvider.Provider>
  );
}

const useQuestionContext = () => useContext(QuestionProvider);

export { useQuestionContext };

export default memo(QuestionsSection);
